@if (labelTitle) {
  <sd-form-libelle
    [idField]="'input-'+uuidInput"
    [labelHidden]="labelHidden"
    [labelTitle]="labelTitle"
    [required]="required"
  />
}

@if (subLabelTitle) {
  <span class="c__sub-label-input">
    {{subLabelTitle}}
  </span>
}

<div
  class="c__wrapper-input {{isSmall ? 'is-small' : ''}} is-type-{{type}}"
  [class.is-active]="isActive"
  [class.is-filled]="isFilled"
>
  <input
    #input
    matInput
    #trigger="matAutocompleteTrigger"
    [matAutocomplete]="auto"
    class="{{isSmall ? 'is-small' : ''}} {{isFake ? 'is-fake-input' : ''}}"
    [attr.aria-invalid]="validStatus"
    [attr.aria-required]="required"
    [class.is-active]="isActive"
    [class.is-filled]="isFilled"
    [autocomplete]="autocomplete"
    [ngClass]="classField"
    [step]="step"
    [id]="'input-' + uuidInput"
    [type]="type"
    [name]="nameField"
    [placeholder]="placeholder"
    [formControl]="internalField"
    [required]="required"
    [readonly]="readonly"
    [attr.maxlength]="maxlength"
    [attr.min]="min ? min : null"
    [attr.max]="max ? max : null"
    (keydown.enter)="onSubmit()"
    (focus)="onFocus()"
    (blur)="onBlur($event)"
  />

  <mat-autocomplete #matAutocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    @if (_suggestions?.length > 0) {
      @for (suggestion of _suggestions; track suggestion) {
        <mat-option [id]="suggestion.key" [value]="suggestion.value"
          [ngClass]="suggestion.description ? 'is-description':''" (click)="selectionMade($event, trigger)">
          <sd-html [html]="highlightSubstring(suggestion.value)" tag="span" />
          <span class="c__option-description">{{ suggestion.description }}</span>
        </mat-option>
      }
    }
  </mat-autocomplete>

  @if (isFormAddon) {
    <ng-content select="[sd-form-addon]" />
  }

  @if (type === 'search' && (isActive || isFilled)) {
    <div class="c__search-buttons">
      @if (type === 'search' && isFilled) {
        <button sd-button
          type="button"
          class="c__search-delete"
          [name]="'forms.a11y.formInput.button.name' | translate"
          (click)="clearInputField(input)"
        >
          <span id="searchDelete" class="is-overline is-bold">{{'forms.delete' | translate}}</span>
        </button>
      }
      @if (type === 'search' && (isActive || isFilled)) {
        <button sd-button
          type="button"
          class="c__search-submit"
          (click)="onSubmit()"
          [theme]="brandThemesEnum.brand"
          [name]="'actions.submitSearch' | translate"
          icon="icon-magnify"
          [isIcon]="true"
          [isSmall]="true"
        ></button>
      }
    </div>
  }
</div>

<ng-content select="[sd-message]" />
